import { axiosInstance } from '../App'
import {
  BiomedicalEquipmentConfigItemDTO,
  BiomedicalEquipmentConfigSavePayloadDTO,
} from '../dto/biomedicalEquipmentConfig/BiomedicalEquipmentConfigDTO'


function toNumber(value: unknown): number {
  if (typeof value === 'number') return Number.isFinite(value) ? value : -1
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : -1
}

function toBoolean(value: unknown): boolean {
  if (typeof value === 'boolean') return value
  if (typeof value === 'number') return value === 1
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase()
    return normalized === 'true' || normalized === '1' || normalized === 't' || normalized === 'yes'
  }
  return false
}

function toStringSafe(value: unknown): string {
  return typeof value === 'string' ? value : String(value ?? '')
}

/* Necesito normalizar????
function normalizeMedicalSpeciality(raw: unknown): MedicalSpecialityItemDTO | null {
  if (typeof raw !== 'object' || raw === null) return null
  const item = raw as Record<string, unknown>
  const id = toNumber(item.medicalspeciality)
  if (id <= 0) return null

  return {
    medicalspeciality: id,
    name: toStringSafe(item.name),
    systemspeciality: toBoolean(item.systemspeciality ?? item.systemSpeciality),
    allowsprescription: toBoolean(item.allowsprescription ?? item.allowsPrescription),
    entitytag: toNumber(item.entitytag ?? item.entityTag),
    entitytagdesc: toStringSafe(item.entitytagdesc ?? item.entityTagDesc),
  }
}


function normalizeProfile(raw: unknown): MedicalSpecialityProfileDTO | null {
  if (typeof raw !== 'object' || raw === null) return null
  const item = raw as Record<string, unknown>
  const id = toNumber(item.id)
  if (id <= 0) return null
  return {
    id,
    name: toStringSafe(item.name),
  }
}
*/

export async function getBiomedicalEquipmentConfigs(): Promise<BiomedicalEquipmentConfigItemDTO[]> {
  const response = await axiosInstance.get('/api/secured/biomedicalEquipmentConfigs/list')
  const array = Array.isArray(response.data) ? response.data : []
  return array
}

export async function createBiomedicalEquipmentConfig(payload: BiomedicalEquipmentConfigSavePayloadDTO): Promise<void> {
  await axiosInstance.post('/api/secured/biomedicalEquipmentConfigs/save', payload)
}

export async function updateBiomedicalEquipmentConfig(
  id: number,
  payload: BiomedicalEquipmentConfigSavePayloadDTO,
): Promise<void> {
  await axiosInstance.post('/api/secured/biomedicalEquipmentConfigs/save', { ...payload, biomedicalEquipmentConfig: id })
}

export async function deleteBiomedicalEquipmentConfig(id: number): Promise<void> {
  await axiosInstance.delete('/api/secured/biomedicalEquipmentConfigs/delete', { params: { id } })
}
